




























































import {
  defineComponent,
  ref,
  onMounted,
} from "@nuxtjs/composition-api";
import CategoryProductCard from "~/modules/catalog/category/components/views/CategoryProductCard.vue";
import { useProductsWithCommonProductCardProps } from "~/modules/catalog/category/components/views/useProductsWithCommonCardProps";
import type { Product } from "~/modules/catalog/product/types";
import { useFacet, useUiHelpers, useSearchProducts } from "~/composables";
import facetGetters from "~/modules/catalog/category/getters/facetGetters";
import { SfLoader, SfPagination, SfSelect } from "@storefront-ui/vue";
import LazyComponent from "v-lazy-component/vue2";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";

export default defineComponent({
  name: "RecentlyViewedProducts",
  components: {
    CategoryProductCard,
    SfLoader,
    SfPagination,
    SfSelect,
    LazyComponent,
    SkeletonLoader,
    ProductLoadItem
  },
  setup() {
    const recentlyViewedSkus = ref<string[]>([]);
    const loadedProducts = ref<Product[]>([]);
    const { fetchProducts, loading } = useSearchProducts();
    const uiHelpers = useUiHelpers();

    const pagination = ref({
      currentPage: 1,
      totalPages: 1,
      itemsPerPage: 8
    });

    const fetchRecentlyViewedProducts = async (page = 1) => {
      if (recentlyViewedSkus.value.length === 0) return;

      const skusToFetch = Array.from(
        recentlyViewedSkus.value.slice(-50).reverse()
      );

      try {
        const params = {
        skus: skusToFetch,
        pageSize: pagination.value.itemsPerPage,
        currentPage: page,
      };
      const { data } = await fetchProducts(params);

        const fetchedProducts = data || [];

        pagination.value.totalPages = Math.ceil(skusToFetch.length / pagination.value.itemsPerPage);
        pagination.value.currentPage = page;

        const productMap = {};
        fetchedProducts.forEach((product) => {
          productMap[product.sku] = product;
        });

        loadedProducts.value = skusToFetch
          .map((sku) => productMap[sku])
          .filter(Boolean);
      } catch (error) {
        console.error("Error fetching recently viewed products:", error);
      }
    };

    const changePage = async (page: number) => {
      await fetchRecentlyViewedProducts(page);
    };

    // const { productsWithCommonProductCardProps } =
    //   useProductsWithCommonProductCardProps(loadedProducts);

    onMounted(() => {
      const storageKey = "vsf-product-viewed";
      if (
        typeof localStorage !== "undefined" &&
        localStorage.getItem(storageKey)
      ) {
        try {
          recentlyViewedSkus.value =
            JSON.parse(localStorage.getItem(storageKey)) || [];
          fetchRecentlyViewedProducts();
        } catch (e) {
          console.error("Failed to parse stored viewed products:", e);
        }
      }
    });

    return {
      // productsWithCommonProps: productsWithCommonProductCardProps,
      products: loadedProducts,
      loading,
      pagination,
      changePage,
    };
  },
});
